import React, { useState } from "react";
import { EventInstrument } from "../types/Instrument";

interface Props {
  availableInstruments: EventInstrument[];
  selectedInstruments: string[]; // Array of selected instrument IDs
  onSelectionChange: (selected: string[]) => void;
}

const InstrumentDropdown: React.FC<Props> = ({
  availableInstruments,
  selectedInstruments,
  onSelectionChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCheckboxChange = (instrumentId: string, isChecked: boolean) => {
    const updatedSelection = isChecked
      ? [...selectedInstruments, instrumentId]
      : selectedInstruments.filter((id) => id !== instrumentId);

    onSelectionChange(updatedSelection);
  };

  return (
    <div style={{ position: "relative", width: "250px", maxWidth: '100vw' }}>
      {/* Dropdown Trigger */}
      <button
        onClick={() => setIsExpanded((prev) => !prev)}
        style={{
          width: "100%",
          padding: "10px",
          textAlign: "left",
          border: "1px solid #ccc",
        }}
      >
        {selectedInstruments.length > 0
          ? `Selected (${selectedInstruments.length})`
          : "Select Instruments"}
      </button>

      {/* Dropdown Content */}
      {isExpanded && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            maxHeight: "300px",
            overflowY: "auto",
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 1000,
            padding: "10px",
            maxWidth: '220px',
            marginTop: '-20px'
          }}
        >
          {availableInstruments.length > 0 ? (
            availableInstruments.map((instrument) => (
              <div key={instrument.instrument_id} style={{ marginBottom: "5px" }}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedInstruments.includes(instrument.instrument_id)}
                    onChange={(e) =>
                      handleCheckboxChange(instrument.instrument_id, e.target.checked)
                    }
                  />
                  {instrument.instrument_name}
                </label>
              </div>
            ))
          ) : (
            <p style={{ color: "#666" }}>No instruments available</p>
          )}
          <button
            onClick={() => setIsExpanded(false)}
            style={{
              marginTop: "10px",
              width: "100%",
              padding: "5px 10px",
            }}
          >
            Done
          </button>
        </div>
      )}
    </div>
  );
};

export default InstrumentDropdown;
